import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, QueryList, Renderer2 } from '@angular/core';

@Directive({
  selector: '[closeOnOutsideClick]'
})
export class CloseOnOutsideClickDirective {
  @Input() items: QueryList<ElementRef>;
  @Output() outsideClick = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    if (!this.items?.length) {
      return;
    }

    const clickedInside = this.items.some(item => item.nativeElement.contains(event.target));

    if (!clickedInside) {
      this.outsideClick.emit();
    }
  }
}
